module.exports = __webpack_public_path__ + "static/media/9_Satutes_Audit_committee_20170631.d028c59d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2017/9_Satutes_Audit_committee_20170631.pdf
// module id = 157
// module chunks = 0